import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

import colors from 'vuetify/lib/util/colors'
Vue.use(Vuetify);
export default new Vuetify({
	theme: {
		themes: {
			light: {
				primary: "#8EB0E5",
				accent: "#db1630",
				secondary: "#CECECE",
				green: "#86BD60",
				black: "#1f2731",
				blueGrey: "#5b6f85"
			},
			dark: {
				primary: colors.blue.lighten3,
			},
		},
	},
})
